import MyBookingsPage from "../components/eventplaces/MyBookingsPage";
import Layout from "../components/layouts/allpagelayout";
export default function MyBookingsPage1() {
  return (
    <Layout>
      <MyBookingsPage/>
    </Layout>
  );
}